/**
 * Catalog product gallery config (static assets under /public/catalog/).
 * Add entries when new packages have dedicated visuals.
 */

const STARTER_SLUG = 'web-comercial-inicial';

const GALLERY_BY_SLUG = {
  [STARTER_SLUG]: [
    {
      src: '/catalog/web-comercial-inicial/01-hero.svg',
      altKey: 'productPage.galleryAltHero'
    },
    {
      src: '/catalog/web-comercial-inicial/02-sections.svg',
      altKey: 'productPage.galleryAltSections'
    },
    {
      src: '/catalog/web-comercial-inicial/03-mobile.svg',
      altKey: 'productPage.galleryAltMobile'
    },
    {
      src: '/catalog/web-comercial-inicial/04-infrastructure.svg',
      altKey: 'productPage.galleryAltInfra'
    },
    {
      src: '/catalog/web-comercial-inicial/05-full.svg',
      altKey: 'productPage.galleryAltFull'
    }
  ]
};

const DEFAULT_GALLERY = [
  {
    src: '/catalog/default/01-service.svg',
    altKey: 'productPage.galleryAltDefault'
  }
];

export function getProductGallery(slug) {
  const key = String(slug || '').trim();
  return GALLERY_BY_SLUG[key] || DEFAULT_GALLERY;
}

export function getProductGalleryThumb(slug) {
  const items = getProductGallery(slug);
  return items[0] || null;
}
